<template>
  <div class="login-wrap">
    <form @submit.prevent="signIn">
      <p class="title">Cardium</p>
      <input v-model="email" type="email" placeholder="Email" autocomplete="email" />
      <input v-model="password" type="password" placeholder="Password" autocomplete="current-password" />
      <p v-if="error" class="error">{{ error }}</p>
      <button type="submit" :disabled="busy">{{ busy ? 'Signing in…' : 'Sign in' }}</button>
    </form>
  </div>
</template>

<script>
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../firebase.js'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: '',
      busy: false,
    }
  },
  methods: {
    async signIn() {
      this.error = ''
      this.busy = true
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password)
      } catch (e) {
        this.error = 'Invalid email or password.'
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style scoped>
.login-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #000;
}
form {
  display: flex;
  flex-direction: column;
  gap: 1.4vh;
  width: 320px;
}
.title {
  color: #fff;
  font-size: 2rem;
  text-align: center;
  margin: 0 0 1vh;
  font-family: sans-serif;
}
input {
  padding: 1.2vh 1.4vw;
  border: 1px solid #444;
  border-radius: 6px;
  background: #111;
  color: #fff;
  font-size: 1rem;
}
input::placeholder { color: #666; }
button {
  padding: 1.2vh;
  background: #2f00ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}
button:disabled { opacity: 0.5; cursor: default; }
.error {
  color: #ff3224;
  font-size: 0.85rem;
  font-family: sans-serif;
  margin: 0;
}
</style>
